import { memo } from 'react';
import { Typography } from '../../../../../components/typography/typography';
import { EditableField } from '../../../../../components/field/field';
import classNames from 'classnames';
import styles from './product-item.module.css';
import { displayMoneyFormat, safeRound } from '../../../../../util/util';
import { ProductItemDataReturn, ProductItemState } from '../../hooks/use-product-item-data';
import { Currency } from 'dinero.js';
import deepEqual from 'deep-equal';

interface ProductItemUnitPriceProps
  extends Pick<ProductItemState, 'isEditing' | 'isTaxInclusive' | 'taxedUnitPrice' | 'unitPrice'> {
  currency: string | Currency;
  updateInputItem: ProductItemDataReturn['updateInputItem'];
}

export const ProductItemUnitPrice = memo<ProductItemUnitPriceProps>(
  ({ isEditing, isTaxInclusive, taxedUnitPrice, unitPrice, currency, updateInputItem }) => {
    if (unitPrice.canEdit && isEditing) {
      return (
        <div>
          <EditableField
            type="number"
            label="Unit Price"
            value={unitPrice.current}
            formattedValue={displayMoneyFormat(unitPrice.current, currency)}
            canReset={unitPrice.canReset}
            resetPosition="right"
            onReset={() => updateInputItem({ customPrice: safeRound(unitPrice.original * 100) })}
            onChange={(value: number) => updateInputItem({ customPrice: safeRound(value * 100) })}
          />
        </div>
      );
    }

    return (
      <Typography
        type="text-sm"
        weight="regular"
        className={classNames(styles.fieldContentText)}
        dataCy="product-item-unit-price-value"
      >
        {displayMoneyFormat(isTaxInclusive ? taxedUnitPrice : unitPrice.current, currency)}
      </Typography>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.isEditing === nextProps.isEditing &&
      prevProps.isTaxInclusive === nextProps.isTaxInclusive &&
      prevProps.taxedUnitPrice === nextProps.taxedUnitPrice &&
      prevProps.currency === nextProps.currency &&
      deepEqual(prevProps.unitPrice, nextProps.unitPrice)
    );
  },
);

ProductItemUnitPrice.displayName = 'ProductItemUnitPrice';
